// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1JsNe","containerItemsCenter":"Skeleton_containerItemsCenter__8__N6"};